import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="notfound-page" className="bg-[#0B1120] text-white min-h-[70vh] flex items-center">
      <div className="container-pr py-24">
        <p className="overline text-cyan-300">404</p>
        <h1 className="font-display mt-3 text-4xl md:text-6xl font-semibold tracking-tight">Page not found.</h1>
        <p className="mt-4 text-slate-300 max-w-xl">The page you were looking for doesn&apos;t exist or has moved. Use the links below to continue.</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" className="btn-primary">Back to home <ArrowUpRight className="h-4 w-4" /></Link>
          <Link to="/contact" className="btn-ghost-dark">Contact us</Link>
        </div>
      </div>
    </div>
  );
}
